<template>
  <div>
    <PageAllow controller="Shops" action="shopStockTakeOrders" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRangeWithRadio
              v-model="options"
              type="datetime"
              :radios="datetimeRadios"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
          </v-row>
        </v-col>
      </v-row>

      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-row dense align="center" class="pa-1">
                <SearchPsiShop v-model="shopSelected" />
              </v-row>
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="stock_take_code"
                  v-model="options.stock_take_code"
                  @text="stockTakeKeyWord = $event"
                  :label="$t('shopStockTakeOrders.stockTakeKeyword')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.status"
                  :items="$consts.stockTakeOrder.status"
                  :label="$t('shopStockTakeOrders.orderStatus.title')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherCancelFlgs v-model="options.cancel_flgs" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="stock_take_orders"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <!-- 仓库名称暂时显示为默认仓库 -->
          <template v-slot:item.stock_name>
            {{ $t("shopStockTakeOrders.Fields.stock") }}
          </template>
          <template v-slot:item.stock_take_code="{ item, index }">
            <span
              class="text-no-wrap caption font-weight-bold"
              :v-resize="!index ? $stickTableResizer() : null"
            >
              {{ item.stock_take_code }}
            </span>
            <span
              class="text-no-wrap caption secondary--text"
              v-if="item.term_date"
            >
              ({{ $t("shopStockTakeOrders.Fields.term_date")
              }}{{ item.term_date | formatTime }})
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | stockTakeOrderStatusColor"
              :text-color="item.status | stockTakeOrderStatusTextColor"
            >
              {{ item.status | stockTakeOrderStatusText }}
            </v-chip>
            <br />
            <v-chip v-if="item.cancel_flg" x-small label outlined color="danger"
              >{{ $t("CRUD.cancelled") }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <StockTakeOrderActions
              :stock_take_order="item"
              :shop_id="shop_id"
              showView
              showExport
            />
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherCancelFlgs from "@/components/plugins/SearcherCancelFlgs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearchPsiShop from "@/components/plugins/SearchPsiShop";
import StockTakeOrderActions from "./plugins/Actions";
import Shops from "@/api/shops";


const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  stock_take_code: "",
  status: [1],
  cancel_flgs: [0],
  shop_id: null,
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherStatus,
    SearcherCancelFlgs,
    SearcherKeyword,
    StockTakeOrderActions,
    SearchPsiShop,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.shopPsi"),
        disabled: false,
        href: "/shop-psi",
      },
      {
        text: i18n.t("Nav.shopStockTakeOrders"),
        disabled: true,
        href: "/shop-stock-take-orders",
      },
    ],
    headers() {
      return [
        {
          text:
            i18n.t("shopStockTakeOrders.Fields.order_code") +
            " / " +
            i18n.t("shopStockTakeOrders.Fields.created_time"),
          align: "start",
          sortable: false,
          value: "stock_take_code",
        },
        {
          text: i18n.t("shopStockTakeOrders.Fields.stock_name"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "stock_name",
        },
        {
          text: i18n.t("shopStockTakeOrders.Fields.categories_total"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "type_count",
        },
        {
          text: i18n.t("shopStockTakeOrders.Fields.operater_name"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "create_name",
        },
        {
          text: i18n.t("shopStockTakeOrders.orderStatus.title"),
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("ShopPsi.created_time"),
      },
    ],
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols"]),
  },

  data: () => ({
    shop_id: null,
    stock_take_orders: [],
    shopSelected: null,
    options: JSON.parse(JSON.stringify(defaultOptions)),
    paging: {},
  }),

  mounted() {
    this.$commonUtils.loadOptions("shop-stock-take-orders", ["shopSelected"]).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        }
        data.selecteds.forEach((selected) => {
          switch (selected.key) {
            case "shopSelected":
              this.shopSelected = selected.value;
              break;
          }
        });
      }.bind(this)
    );
  },

  methods: {
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.shopSelected = null;
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        stock_take_code: this.stockTakeKeyWord,
      });
    },
    getShopStockTakeOrdersFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      options = Object.assign({}, options, { shop_id: this.shop_id })
      Shops.shopStockTakeOrders(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_take_orders = response.data.stock_takes;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        if (this.shopSelected) {
          this.getShopStockTakeOrdersFromAPI();
          sessionStorage.setItem(
            "shop-stock-take-orders-options",
            JSON.stringify(this.options)
          );
        }
      },
    },
    shopSelected: {
      handler() {
        this.shop_id = this.shopSelected ? this.shopSelected.id : null;
        if (this.shopSelected) {
          this.getShopStockTakeOrdersFromAPI();
        } else {
          this.paging = [];
          this.stock_take_orders = [];
        }
        sessionStorage.setItem(
          "shop-stock-take-orders-shopSelected",
          JSON.stringify(this.shopSelected)
        );
      },
    },
  },
};
</script>